module.exports = __webpack_public_path__ + "static/media/troy-evans.e20e405e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/documents/troy-evans.pdf
// module id = 65
// module chunks = 0